<template>
  <div class="pg-upload">
    <span v-if="disabled && fileList.length === 0">-</span>
    <span
      class="pg-upload__text"
      v-if="disabled && !showFileList && fileList.length > 0"
      @click.stop="handView(fileList[0])"
      >{{ viewText }}</span
    >
    <Upload
      v-if="!disabled"
      :drag="drag"
      :auto-upload="true"
      :action="actionUrl"
      :data="param"
      :headers="headers"
      :multiple="multiple"
      :show-file-list="false"
      :limit="limit"
      :before-upload="onBeforeUpload"
      :on-success="onSuccess"
      :on-error="onError"
      :on-exceed="onExceed"
      :disabled="disabled"
    >
      <template #default>
        <slot name="default">
          <span
            class="pg-upload__text"
            v-if="!showFileList && fileList.length > 0"
            @click.stop="handView(fileList[0])"
            >{{ viewText }}</span
          >
          <span class="pg-upload__text">{{ text }}</span>
          <Popover
            class="pg-upload__text-tip"
            popper-class="pg-upload__text-tip__popper"
            trigger="hover"
            placement="bottom"
            :content="textTip"
            width="205"
          >
            <template #reference>
              <span>?</span>
            </template>
          </Popover>
        </slot>
      </template>
    </Upload>
    <transition-group
      tag="div"
      name="pg-list"
      class="pg-upload__privew-list"
      :class="{ 'pg-upload__privew-list__edit': !disabled }"
      v-if="showFileList && fileList.length > 0"
    >
      <div
        class="pg-upload__privew-item"
        :style="privewItemStyle"
        v-for="file in fileList"
        :key="file.id"
      >
        <img class="pg-upload__privew-item-img" v-if="ifImg(file)" :src="file.url" />
        <img class="pg-upload__privew-item-img" v-else :src="getFileIcon(file)" />
        <div class="pg-upload__privew-item-actions">
          <i class="ivu-icon-icon-pg-xianshi" @click="handView(file)"></i>
          <i class="ivu-icon-icon-pg-xiazai" v-if="showDownload" @click="download(file)"></i>
          <i class="ivu-icon-icon-pg-delete" v-if="!disabled" @click="remove(file)"></i>
        </div>
      </div>
    </transition-group>
    <PgFilePreviewDialog
      :visible.sync="visible"
      :value="fileList"
      :current="currentFile"
      :multiple="multiple"
      :remove="!disabled"
      @on-remove="onRemove"
    />
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>
<script setup>
import { ref, computed } from 'vue'
import { Upload, Popover } from 'element-ui'
import { PgFilePreviewDialog } from '../../file-preview/index'
import { createID } from '../../../utils/index'
import { useUpload } from '../hooks/index'

const emit = defineEmits(['input'])

const props = defineProps({
  value: { type: [String, Array] },
  action: { type: String, default: 'rest/ezcomp/file/uploadFile' },
  actionParam: {
    type: Object,
    default() {
      return {}
    },
  },
  catalogCode: { type: String, default: 'ORDER_INFO' },
  drag: Boolean,
  disabled: { type: Boolean, default: false },
  multiple: { type: Boolean, default: true },
  valueIsObj: { type: Boolean, default: true },
  limit: { type: Number },
  // 允许上传最大的文件（单位b） 10M = 10 * 1024 * 1024
  maxSize: { type: Number, default: 100 * 1024 * 1024 },
  format: {
    type: Array,
    default: () => [
      'jpg',
      'jpeg',
      'png',
      'bmp',
      'gif',
      'docx',
      'doc',
      'xlsx',
      'xls',
      'pdf',
      'rar',
      'zip',
    ],
  },
  text: { type: String, default: '上传附件' },
  viewText: { type: String, default: '查看附件' },
  submitUrl: String,
  submitMethod: {
    type: String,
    default: 'post',
  },
  submitParam: Object,
  // 预览图片显示样式
  privewItemStyle: Object,
  showDownload: {
    type: Boolean,
    default: true,
  },
  showFileList: Boolean,
})

const param = computed(() => {
  const tmp = { ...props.actionParam }
  if (props.catalogCode) tmp.catalogCode = props.catalogCode

  return tmp
})

const textTip = computed(() => {
  return `上传文件小于${props.maxSize / 1024 / 1024}MB，支持类型：${props.format.join('/')}`
})

const visible = ref(false)
const currentFile = ref(null)
const handView = (file) => {
  currentFile.value = file
  visible.value = true
}

const fileList = computed(() => {
  if (!props.value) return []
  if (props.valueIsObj) {
    return props.multiple ? props.value : [props.value]
  } else {
    let tempVal = props.multiple
      ? Array.isArray(props.value)
        ? props.value
        : props.value.split(',')
      : [props.value]
    return tempVal.map((item) => {
      const tmp = item.split('/')
      const len = tmp.length

      const name = tmp[len - 1]
      return { url: item, name, id: createID() }
    })
  }
})

const {
  actionUrl,
  headers,
  onBeforeUpload,
  onSuccess,
  onError,
  onExceed,
  remove,
  download,
  getFileIcon,
  ifImg,
} = useUpload({
  fileList,
  props,
  emit,
})

const onRemove = (file) => {
  if (props.disabled) return
  const index = fileList.value.findIndex((item) => item.id === file.id)
  remove(file)
  const temp = fileList.value[index + 1] || fileList.value[0]
  currentFile.value = props.valueIsObj ? temp : { url: temp.url }
}
</script>
<style lang="scss">
@import '../style/upload.scss';
</style>
